import { showNotification } from "@mantine/notifications";

// 操作に成功した時の通知
export const successShowNotification = (message: string) => {
  return showNotification({
    autoClose: 2000,
    disallowClose: true,
    message,
    styles: (theme) => {
      return {
        description: {
          color: theme.white,
          textAlign: "center",
        },
        root: {
          "&::before": { display: "none" },
          backgroundColor: "#2D3336",
          borderColor: "#2D3336",
          padding: "12px 0",
        },
      };
    },
  });
};

// 操作に失敗した時の通知
export const errorShowNotification = (message: string) => {
  return showNotification({
    autoClose: 2000,
    disallowClose: true,
    message,
    styles: () => {
      return {
        description: {
          color: "#fa5252",
          textAlign: "center",
        },
        root: {
          "&::before": { display: "none" },
          backgroundColor: "#2D3336",
          borderColor: "#2D3336",
          padding: "12px 0",
        },
      };
    },
  });
};

//ポイントを獲得したときの通知
export const pointGetShowNotification = (
  missionText: string, //ミッション内容
  point: number, //ミッション完了時獲得ポイント
) => {
  return showNotification({
    autoClose: 2000,
    disallowClose: true,
    message: missionText,
    styles: (theme) => {
      return {
        description: {
          color: theme.white,
          textAlign: "center",
        },
        root: {
          "&::before": { display: "none" },
          backgroundColor: "#2D3336",
          borderColor: "#2D3336",
          padding: "12px 0",
        },
        title: {
          color: theme.white,
          fontSize: 20,
          textAlign: "center",
        },
      };
    },
    title: point.toString() + "ポイント獲得しました",
  });
};
